import { search } from "../../assets/js/api.js";
import store from "@/store";
import { processDayConsumptionResults, processTitleCodeConsumptionResults } from '@/assets/js/utils';

export default {
  namespaced: true,
  state: {
    consumptionResultsQuery: {},
    dayConsumptionNormalResults: {
      state: "NOT_LOADED",
      chartData: {}
    },
    dayConsumptionCumulativeResults: {
      state: "NOT_LOADED",
      chartData: {}
    },
    dayConsumptionAggregatedNormalResults: {
      state: "NOT_LOADED",
      chartData: {}
    },
    dayConsumptionAggregatedCumulativeResults: {
      state: "NOT_LOADED",
      chartData: {}
    },
    titleCodeConsumptionNormalResults: {
      state: "NOT_LOADED",
      data: []
    },
    titleCodeConsumptionCumulativeResults: {
      state: "NOT_LOADED",
      data: []
    },
    hasMultipleDaysData: false,
    consumptionTargetGroups: [],
    panelDay: "",
    showToastError: false
  },
  getters: {
    consumptionResultsQuery: state => state.consumptionResultsQuery,
    dayConsumptionNormalResults: state => state.dayConsumptionNormalResults,
    dayConsumptionCumulativeResults: state => state.dayConsumptionCumulativeResults,
    dayConsumptionAggregatedNormalResults: state => state.dayConsumptionAggregatedNormalResults,
    dayConsumptionAggregatedCumulativeResults: state => state.dayConsumptionAggregatedCumulativeResults,
    titleCodeConsumptionNormalResults: state => state.titleCodeConsumptionNormalResults,
    titleCodeConsumptionCumulativeResults: state => state.titleCodeConsumptionCumulativeResults,
    consumptionTargetGroups: state => state.consumptionTargetGroups,
    hasMultipleDaysData: state => state.hasMultipleDaysData,
    panelDay: state => state.panelDay
  },
  mutations: {
    resetAllResults: (state) => {
      state.dayConsumptionNormalResults = { state: "NOT_LOADED", chartData: {} };
      state.dayConsumptionCumulativeResults = { state: "NOT_LOADED", chartData: {} };
      state.dayConsumptionAggregatedNormalResults = { state: "NOT_LOADED", chartData: {} };
      state.dayConsumptionAggregatedCumulativeResults = { state: "NOT_LOADED", chartData: {} };
      state.titleCodeConsumptionNormalResults = { state: "NOT_LOADED", data: [] };
      state.titleCodeConsumptionCumulativeResults = { state: "NOT_LOADED", data: [] };
      state.hasMultipleDaysData = false;
      state.consumptionTargetGroups = [];
      state.showToastError = false;
    },
    setConsumptionResultsQuery: (state, payload) => state.consumptionResultsQuery = payload,
    setDayConsumptionNormalResults: (state, payload) => state.dayConsumptionNormalResults = payload,
    setDayConsumptionCumulativeResults: (state, payload) => state.dayConsumptionCumulativeResults = payload,
    setDayConsumptionAggregatedNormalResults: (state, payload) => state.dayConsumptionAggregatedNormalResults = payload,
    setDayConsumptionAggregatedCumulativeResults: (state, payload) => state.dayConsumptionAggregatedCumulativeResults = payload,
    setTitleCodeConsumptionNormalResults: (state, payload) => state.titleCodeConsumptionNormalResults = payload,
    setTitleCodeConsumptionCumulativeResults: (state, payload) => state.titleCodeConsumptionCumulativeResults = payload,
    setHasMultipleDaysData: (state, payload) => state.hasMultipleDaysData = payload,
    setConsumptionTargetGroups: (state, payload) => state.consumptionTargetGroups = payload,
    setShowToastError: (state, payload) => state.showToastError = payload,
    updateTitleCodes: (state, payload) => state.consumptionResultsQuery.title_codes = payload
  },
  actions: {
    initialize: async (context) => {
      context.commit("resetAllResults");
      const measuresMetaData = context.state.consumptionResultsQuery.measures
      const uniqueTargetGroupsArray = [...new Set(measuresMetaData.map(detail => `${detail.genderAndAge} ${detail.reachCriteriaText}`))];
      context.commit('setConsumptionTargetGroups', uniqueTargetGroupsArray);
      const hasMultipleDaysData = context.state.consumptionResultsQuery.uniqueDatesInPeriod.length > 1
      context.commit('setHasMultipleDaysData', hasMultipleDaysData)
      context.commit('updateTitleCodes',  store.getters['consumptionApiBody/consumptionApiBody'].title_codes);
      await context.dispatch('searchDayConsumption', {
        mutationName: 'setDayConsumptionNormalResults',
        getCumulativeMeasurements: false,
        getAggregatedData: false
      })
    },
    searchDayConsumption: async (context, { 
      mutationName, 
      getCumulativeMeasurements, 
      getAggregatedData 
    }) => {
      context.commit(mutationName, { state: "LOADING", chartData: {} });
      try {
          const payload = context.state.consumptionResultsQuery
          const endpoint = 'QueryData/DayConsumption';
          const result = await search(endpoint, { getCumulativeMeasurements, getAggregatedData, payload });

          if (result.statusCode) {
              context.commit("setShowToastError", true);
          } else {
              const chartData = processDayConsumptionResults(result, context.state.consumptionTargetGroups);
              context.commit(mutationName, { state: "LOADED", chartData });
          }
      } catch (error) {
          console.error("API error: " + error);
          context.commit("setShowToastError", true);
          context.commit(mutationName, { state: "ERROR", chartData: {} });
      }
    },
    searchTitleCodeConsumption: async (context, { 
      mutationName, 
      getCumulativeMeasurements, 
      getAggregatedData 
    }) => {
      context.commit(mutationName, { state: "LOADING", chartData: {} });
      try {
          const payload = context.state.consumptionResultsQuery
          const endpoint = 'QueryData/TitleCodeConsumption';
          const result = await search(endpoint, { getCumulativeMeasurements, getAggregatedData, payload });

          if (result.statusCode) {
              context.commit("setShowToastError", true);
          } else {
            const chartData = processTitleCodeConsumptionResults(result, context.state.consumptionTargetGroups, context.state.consumptionResultsQuery.uniqueDatesInPeriod);
            context.commit(mutationName, { state: "LOADED", chartData });
          }
      } catch (error) {
          console.error("API error: " + error);
          context.commit("setShowToastError", true);
          context.commit(mutationName, { state: "ERROR", chartData: {} });
      }
    },
  }
};


